"use client";

export default function CookiePreferencesButton({ className, children }) {
  const label = children || "Manage preferences";
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        if (typeof window === "undefined") return;
        window.dispatchEvent(new Event("flare-cookie-preferences"));
      }}
    >
      {label}
    </button>
  );
}
